import { usePwa } from '../PwaProvider';
export const usePwaUpdate = () => { const { updateReady, updating, updateNow, checkVersion } = usePwa(); return { updateReady, updating, updateNow, checkVersion }; };
